/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  FinancialReportingConfigurationStatus
} from '../../model/financialReportingConfigurationStatus'
import type {
  FundEntityReadDataList
} from '../../model/fundEntityReadDataList'
import type {
  FundFamilyUseAllocationTableDataWithDefinition
} from '../../model/fundFamilyUseAllocationTableDataWithDefinition'
import type {
  FundHypotheticalProtectedClawbackInfoDataByFund
} from '../../model/fundHypotheticalProtectedClawbackInfoDataByFund'
import type {
  GenericChartData
} from '../../model/genericChartData'
import type {
  GenericTableData
} from '../../model/genericTableData'
import type {
  HypotheticalFundDetailsData
} from '../../model/hypotheticalFundDetailsData'
import type {
  HypotheticalPerformanceFilterData
} from '../../model/hypotheticalPerformanceFilterData'
import type {
  HypotheticalWaterfallAPITableCreateRequest
} from '../../model/hypotheticalWaterfallAPITableCreateRequest'
import type {
  HypotheticalWaterfallCapitalActivityBreakdownAPIData
} from '../../model/hypotheticalWaterfallCapitalActivityBreakdownAPIData'
import type {
  HypotheticalWaterfallCapitalActivityDataRetrieveParams
} from '../../model/hypotheticalWaterfallCapitalActivityDataRetrieveParams'
import type {
  HypotheticalWaterfallCreateDataAPIData
} from '../../model/hypotheticalWaterfallCreateDataAPIData'
import type {
  HypotheticalWaterfallData
} from '../../model/hypotheticalWaterfallData'
import type {
  HypotheticalWaterfallDataRetrieveParams
} from '../../model/hypotheticalWaterfallDataRetrieveParams'
import type {
  HypotheticalWaterfallDetailsBreakdownRetrieveParams
} from '../../model/hypotheticalWaterfallDetailsBreakdownRetrieveParams'
import type {
  HypotheticalWaterfallFundPerformanceDetailsRetrieveParams
} from '../../model/hypotheticalWaterfallFundPerformanceDetailsRetrieveParams'
import type {
  HypotheticalWaterfallIRRBreakdownRetrieveParams
} from '../../model/hypotheticalWaterfallIRRBreakdownRetrieveParams'
import type {
  HypotheticalWaterfallNAVBreakdownAPIData
} from '../../model/hypotheticalWaterfallNAVBreakdownAPIData'
import type {
  HypotheticalWaterfallNavBreakdownRetrieveParams
} from '../../model/hypotheticalWaterfallNavBreakdownRetrieveParams'
import type {
  HypotheticalWaterfallPerformanceBreakdownAPIData
} from '../../model/hypotheticalWaterfallPerformanceBreakdownAPIData'
import type {
  HypotheticalWaterfallPerformanceBreakdownRetrieveParams
} from '../../model/hypotheticalWaterfallPerformanceBreakdownRetrieveParams'
import type {
  HypotheticalWaterfallPerformanceFilterDataRetrieveParams
} from '../../model/hypotheticalWaterfallPerformanceFilterDataRetrieveParams'
import type {
  HypotheticalWaterfallPerformanceMultiplesAPIData
} from '../../model/hypotheticalWaterfallPerformanceMultiplesAPIData'
import type {
  HypotheticalWaterfallPerformanceMultiplesRetrieveParams
} from '../../model/hypotheticalWaterfallPerformanceMultiplesRetrieveParams'
import type {
  HypotheticalWaterfallPerformanceStatsByPeriodRetrieveParams
} from '../../model/hypotheticalWaterfallPerformanceStatsByPeriodRetrieveParams'
import type {
  HypotheticalWaterfallPreferredBreakdownAPIData
} from '../../model/hypotheticalWaterfallPreferredBreakdownAPIData'
import type {
  HypotheticalWaterfallPreferredReturnSummaryRetrieveParams
} from '../../model/hypotheticalWaterfallPreferredReturnSummaryRetrieveParams'
import type {
  HypotheticalWaterfallProtectedClawbackAPICreateDataRequest
} from '../../model/hypotheticalWaterfallProtectedClawbackAPICreateDataRequest'
import type {
  IRRBreakdownAPIData
} from '../../model/iRRBreakdownAPIData'
import type {
  WaterfallDistributionData
} from '../../model/waterfallDistributionData'
import { axiosRequest } from '../../../shared/api/Api';


      
type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];



      import { appQueryClient } from "app/AppQueryClient";
      import { LoaderFunction, Params } from "@remix-run/router";
      import { isLoggedIn } from "axios-jwt";

      const authedLoader = (loader: LoaderFunction): LoaderFunction =>
        async (args) => {
          const result = await isLoggedIn();
          if (result) {
            return loader(args);
          }
          return null;
        };
    /**
 * Gets hypothetical waterfall performance table by period (for a commitment, investor, investor entity)
 */
export const hypotheticalWaterfallPerformanceStatsByPeriodRetrieve = (
    params?: HypotheticalWaterfallPerformanceStatsByPeriodRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/financial-reporting/performance-stats-by-period`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getHypotheticalWaterfallPerformanceStatsByPeriodRetrieveQueryKey = (params?: HypotheticalWaterfallPerformanceStatsByPeriodRetrieveParams,) => {
    return [`/financial-reporting/performance-stats-by-period`, ...(params ? [params]: [])] as const;
    }

    
export const getHypotheticalWaterfallPerformanceStatsByPeriodRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallPerformanceStatsByPeriodRetrieve>>, TError = unknown>(params?: HypotheticalWaterfallPerformanceStatsByPeriodRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallPerformanceStatsByPeriodRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHypotheticalWaterfallPerformanceStatsByPeriodRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof hypotheticalWaterfallPerformanceStatsByPeriodRetrieve>>> = ({ signal }) => hypotheticalWaterfallPerformanceStatsByPeriodRetrieve(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallPerformanceStatsByPeriodRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type HypotheticalWaterfallPerformanceStatsByPeriodRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof hypotheticalWaterfallPerformanceStatsByPeriodRetrieve>>>
export type HypotheticalWaterfallPerformanceStatsByPeriodRetrieveQueryError = unknown

export const useHypotheticalWaterfallPerformanceStatsByPeriodRetrieve = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallPerformanceStatsByPeriodRetrieve>>, TError = unknown>(
 params?: HypotheticalWaterfallPerformanceStatsByPeriodRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallPerformanceStatsByPeriodRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getHypotheticalWaterfallPerformanceStatsByPeriodRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getHypotheticalWaterfallPerformanceStatsByPeriodRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallPerformanceStatsByPeriodRetrieve>>, TError = unknown>(params?: HypotheticalWaterfallPerformanceStatsByPeriodRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallPerformanceStatsByPeriodRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHypotheticalWaterfallPerformanceStatsByPeriodRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof hypotheticalWaterfallPerformanceStatsByPeriodRetrieve>>> = ({ signal }) => hypotheticalWaterfallPerformanceStatsByPeriodRetrieve(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallPerformanceStatsByPeriodRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type HypotheticalWaterfallPerformanceStatsByPeriodRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof hypotheticalWaterfallPerformanceStatsByPeriodRetrieve>>>
export type HypotheticalWaterfallPerformanceStatsByPeriodRetrieveSuspenseQueryError = unknown

export const useHypotheticalWaterfallPerformanceStatsByPeriodRetrieveSuspense = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallPerformanceStatsByPeriodRetrieve>>, TError = unknown>(
 params?: HypotheticalWaterfallPerformanceStatsByPeriodRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallPerformanceStatsByPeriodRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getHypotheticalWaterfallPerformanceStatsByPeriodRetrieveSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getHypotheticalWaterfallPerformanceStatsByPeriodRetrieveLoader = (queryParamsOrFn?: (HypotheticalWaterfallPerformanceStatsByPeriodRetrieveParams | ((params: Params) => HypotheticalWaterfallPerformanceStatsByPeriodRetrieveParams))): LoaderFunction =>
        authedLoader(({ params }) => {
          const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          return appQueryClient.prefetchQuery({
            queryKey: getHypotheticalWaterfallPerformanceStatsByPeriodRetrieveQueryKey(queryParams),
            queryFn: () => hypotheticalWaterfallPerformanceStatsByPeriodRetrieve(queryParams),
          }).then(() => null);
        });
      /**
 * Gets filters for hypothetical waterfall performance tab
 */
export const hypotheticalWaterfallPerformanceFilterDataRetrieve = (
    params?: HypotheticalWaterfallPerformanceFilterDataRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<HypotheticalPerformanceFilterData>(
      {url: `/financial-reporting/performance-stats-filters`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getHypotheticalWaterfallPerformanceFilterDataRetrieveQueryKey = (params?: HypotheticalWaterfallPerformanceFilterDataRetrieveParams,) => {
    return [`/financial-reporting/performance-stats-filters`, ...(params ? [params]: [])] as const;
    }

    
export const getHypotheticalWaterfallPerformanceFilterDataRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallPerformanceFilterDataRetrieve>>, TError = unknown>(params?: HypotheticalWaterfallPerformanceFilterDataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallPerformanceFilterDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHypotheticalWaterfallPerformanceFilterDataRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof hypotheticalWaterfallPerformanceFilterDataRetrieve>>> = ({ signal }) => hypotheticalWaterfallPerformanceFilterDataRetrieve(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallPerformanceFilterDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type HypotheticalWaterfallPerformanceFilterDataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof hypotheticalWaterfallPerformanceFilterDataRetrieve>>>
export type HypotheticalWaterfallPerformanceFilterDataRetrieveQueryError = unknown

export const useHypotheticalWaterfallPerformanceFilterDataRetrieve = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallPerformanceFilterDataRetrieve>>, TError = unknown>(
 params?: HypotheticalWaterfallPerformanceFilterDataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallPerformanceFilterDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getHypotheticalWaterfallPerformanceFilterDataRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getHypotheticalWaterfallPerformanceFilterDataRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallPerformanceFilterDataRetrieve>>, TError = unknown>(params?: HypotheticalWaterfallPerformanceFilterDataRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallPerformanceFilterDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHypotheticalWaterfallPerformanceFilterDataRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof hypotheticalWaterfallPerformanceFilterDataRetrieve>>> = ({ signal }) => hypotheticalWaterfallPerformanceFilterDataRetrieve(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallPerformanceFilterDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type HypotheticalWaterfallPerformanceFilterDataRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof hypotheticalWaterfallPerformanceFilterDataRetrieve>>>
export type HypotheticalWaterfallPerformanceFilterDataRetrieveSuspenseQueryError = unknown

export const useHypotheticalWaterfallPerformanceFilterDataRetrieveSuspense = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallPerformanceFilterDataRetrieve>>, TError = unknown>(
 params?: HypotheticalWaterfallPerformanceFilterDataRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallPerformanceFilterDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getHypotheticalWaterfallPerformanceFilterDataRetrieveSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getHypotheticalWaterfallPerformanceFilterDataRetrieveLoader = (queryParamsOrFn?: (HypotheticalWaterfallPerformanceFilterDataRetrieveParams | ((params: Params) => HypotheticalWaterfallPerformanceFilterDataRetrieveParams))): LoaderFunction =>
        authedLoader(({ params }) => {
          const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          return appQueryClient.prefetchQuery({
            queryKey: getHypotheticalWaterfallPerformanceFilterDataRetrieveQueryKey(queryParams),
            queryFn: () => hypotheticalWaterfallPerformanceFilterDataRetrieve(queryParams),
          }).then(() => null);
        });
      /**
 * Get hypothetical create data
 */
export const hypotheticalWaterfallCreateDataRetrieve = (
    fundFamilyId: string,
    endOfPeriodReportId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<HypotheticalWaterfallCreateDataAPIData>(
      {url: `/fund-family/${fundFamilyId}/financial-reporting/${endOfPeriodReportId}/create-data`, method: 'GET', signal
    },
      options);
    }
  

export const getHypotheticalWaterfallCreateDataRetrieveQueryKey = (fundFamilyId: string,
    endOfPeriodReportId: string,) => {
    return [`/fund-family/${fundFamilyId}/financial-reporting/${endOfPeriodReportId}/create-data`] as const;
    }

    
export const getHypotheticalWaterfallCreateDataRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallCreateDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    endOfPeriodReportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallCreateDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHypotheticalWaterfallCreateDataRetrieveQueryKey(fundFamilyId,endOfPeriodReportId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof hypotheticalWaterfallCreateDataRetrieve>>> = ({ signal }) => hypotheticalWaterfallCreateDataRetrieve(fundFamilyId,endOfPeriodReportId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && endOfPeriodReportId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallCreateDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type HypotheticalWaterfallCreateDataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof hypotheticalWaterfallCreateDataRetrieve>>>
export type HypotheticalWaterfallCreateDataRetrieveQueryError = unknown

export const useHypotheticalWaterfallCreateDataRetrieve = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallCreateDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    endOfPeriodReportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallCreateDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getHypotheticalWaterfallCreateDataRetrieveQueryOptions(fundFamilyId,endOfPeriodReportId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getHypotheticalWaterfallCreateDataRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallCreateDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    endOfPeriodReportId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallCreateDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHypotheticalWaterfallCreateDataRetrieveQueryKey(fundFamilyId,endOfPeriodReportId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof hypotheticalWaterfallCreateDataRetrieve>>> = ({ signal }) => hypotheticalWaterfallCreateDataRetrieve(fundFamilyId,endOfPeriodReportId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && endOfPeriodReportId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallCreateDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type HypotheticalWaterfallCreateDataRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof hypotheticalWaterfallCreateDataRetrieve>>>
export type HypotheticalWaterfallCreateDataRetrieveSuspenseQueryError = unknown

export const useHypotheticalWaterfallCreateDataRetrieveSuspense = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallCreateDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    endOfPeriodReportId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallCreateDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getHypotheticalWaterfallCreateDataRetrieveSuspenseQueryOptions(fundFamilyId,endOfPeriodReportId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getHypotheticalWaterfallCreateDataRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,endOfPeriodReportId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,endOfPeriodReportId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && endOfPeriodReportId) {
            return appQueryClient.prefetchQuery({
              queryKey: getHypotheticalWaterfallCreateDataRetrieveQueryKey(fundFamilyId,endOfPeriodReportId),
              queryFn: () => hypotheticalWaterfallCreateDataRetrieve(fundFamilyId,endOfPeriodReportId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Gets a hypothetical waterfall
 */
export const hypotheticalWaterfallRetrieve = (
    fundFamilyId: string,
    endOfPeriodReportId: string,
    hypotheticalWaterfallId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<HypotheticalWaterfallData>(
      {url: `/fund-family/${fundFamilyId}/financial-reporting/${endOfPeriodReportId}/hypothetical-waterfall/${hypotheticalWaterfallId}`, method: 'GET', signal
    },
      options);
    }
  

export const getHypotheticalWaterfallRetrieveQueryKey = (fundFamilyId: string,
    endOfPeriodReportId: string,
    hypotheticalWaterfallId: string,) => {
    return [`/fund-family/${fundFamilyId}/financial-reporting/${endOfPeriodReportId}/hypothetical-waterfall/${hypotheticalWaterfallId}`] as const;
    }

    
export const getHypotheticalWaterfallRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallRetrieve>>, TError = unknown>(fundFamilyId: string,
    endOfPeriodReportId: string,
    hypotheticalWaterfallId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHypotheticalWaterfallRetrieveQueryKey(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof hypotheticalWaterfallRetrieve>>> = ({ signal }) => hypotheticalWaterfallRetrieve(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && endOfPeriodReportId && hypotheticalWaterfallId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type HypotheticalWaterfallRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof hypotheticalWaterfallRetrieve>>>
export type HypotheticalWaterfallRetrieveQueryError = unknown

export const useHypotheticalWaterfallRetrieve = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    endOfPeriodReportId: string,
    hypotheticalWaterfallId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getHypotheticalWaterfallRetrieveQueryOptions(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getHypotheticalWaterfallRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallRetrieve>>, TError = unknown>(fundFamilyId: string,
    endOfPeriodReportId: string,
    hypotheticalWaterfallId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHypotheticalWaterfallRetrieveQueryKey(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof hypotheticalWaterfallRetrieve>>> = ({ signal }) => hypotheticalWaterfallRetrieve(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && endOfPeriodReportId && hypotheticalWaterfallId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type HypotheticalWaterfallRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof hypotheticalWaterfallRetrieve>>>
export type HypotheticalWaterfallRetrieveSuspenseQueryError = unknown

export const useHypotheticalWaterfallRetrieveSuspense = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    endOfPeriodReportId: string,
    hypotheticalWaterfallId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getHypotheticalWaterfallRetrieveSuspenseQueryOptions(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getHypotheticalWaterfallRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,endOfPeriodReportId: string,hypotheticalWaterfallId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && endOfPeriodReportId && hypotheticalWaterfallId) {
            return appQueryClient.prefetchQuery({
              queryKey: getHypotheticalWaterfallRetrieveQueryKey(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId),
              queryFn: () => hypotheticalWaterfallRetrieve(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Deletes a hypothetical waterfall
 */
export const hypotheticalWaterfallDelete = (
    fundFamilyId: string,
    endOfPeriodReportId: string,
    hypotheticalWaterfallId: string,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/fund-family/${fundFamilyId}/financial-reporting/${endOfPeriodReportId}/hypothetical-waterfall/${hypotheticalWaterfallId}`, method: 'DELETE'
    },
      options);
    }
  


export const getHypotheticalWaterfallDeleteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hypotheticalWaterfallDelete>>, TError,{fundFamilyId: string;endOfPeriodReportId: string;hypotheticalWaterfallId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof hypotheticalWaterfallDelete>>, TError,{fundFamilyId: string;endOfPeriodReportId: string;hypotheticalWaterfallId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hypotheticalWaterfallDelete>>, {fundFamilyId: string;endOfPeriodReportId: string;hypotheticalWaterfallId: string}> = (props) => {
          const {fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId} = props ?? {};

          return  hypotheticalWaterfallDelete(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type HypotheticalWaterfallDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof hypotheticalWaterfallDelete>>>
    
    export type HypotheticalWaterfallDeleteMutationError = unknown

    export const useHypotheticalWaterfallDelete = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hypotheticalWaterfallDelete>>, TError,{fundFamilyId: string;endOfPeriodReportId: string;hypotheticalWaterfallId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getHypotheticalWaterfallDeleteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Persist protected clawback
 */
export const hypotheticalWaterfallProtectedClawbackCreate = (
    fundFamilyId: string,
    endOfPeriodReportId: string,
    hypotheticalWaterfallId: string,
    hypotheticalWaterfallProtectedClawbackAPICreateDataRequest: HypotheticalWaterfallProtectedClawbackAPICreateDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/fund-family/${fundFamilyId}/financial-reporting/${endOfPeriodReportId}/hypothetical-waterfall/${hypotheticalWaterfallId}/carry-clawback-protected`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: hypotheticalWaterfallProtectedClawbackAPICreateDataRequest
    },
      options);
    }
  


export const getHypotheticalWaterfallProtectedClawbackCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hypotheticalWaterfallProtectedClawbackCreate>>, TError,{fundFamilyId: string;endOfPeriodReportId: string;hypotheticalWaterfallId: string;data: HypotheticalWaterfallProtectedClawbackAPICreateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof hypotheticalWaterfallProtectedClawbackCreate>>, TError,{fundFamilyId: string;endOfPeriodReportId: string;hypotheticalWaterfallId: string;data: HypotheticalWaterfallProtectedClawbackAPICreateDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hypotheticalWaterfallProtectedClawbackCreate>>, {fundFamilyId: string;endOfPeriodReportId: string;hypotheticalWaterfallId: string;data: HypotheticalWaterfallProtectedClawbackAPICreateDataRequest}> = (props) => {
          const {fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId,data} = props ?? {};

          return  hypotheticalWaterfallProtectedClawbackCreate(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type HypotheticalWaterfallProtectedClawbackCreateMutationResult = NonNullable<Awaited<ReturnType<typeof hypotheticalWaterfallProtectedClawbackCreate>>>
    export type HypotheticalWaterfallProtectedClawbackCreateMutationBody = HypotheticalWaterfallProtectedClawbackAPICreateDataRequest
    export type HypotheticalWaterfallProtectedClawbackCreateMutationError = unknown

    export const useHypotheticalWaterfallProtectedClawbackCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hypotheticalWaterfallProtectedClawbackCreate>>, TError,{fundFamilyId: string;endOfPeriodReportId: string;hypotheticalWaterfallId: string;data: HypotheticalWaterfallProtectedClawbackAPICreateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getHypotheticalWaterfallProtectedClawbackCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Updates state of hypo waterfall in system to complete
 */
export const hypotheticalWaterfallDraftToComplete = (
    fundFamilyId: string,
    endOfPeriodReportId: string,
    hypotheticalWaterfallId: string,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/fund-family/${fundFamilyId}/financial-reporting/${endOfPeriodReportId}/hypothetical-waterfall/${hypotheticalWaterfallId}/complete`, method: 'PATCH'
    },
      options);
    }
  


export const getHypotheticalWaterfallDraftToCompleteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hypotheticalWaterfallDraftToComplete>>, TError,{fundFamilyId: string;endOfPeriodReportId: string;hypotheticalWaterfallId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof hypotheticalWaterfallDraftToComplete>>, TError,{fundFamilyId: string;endOfPeriodReportId: string;hypotheticalWaterfallId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hypotheticalWaterfallDraftToComplete>>, {fundFamilyId: string;endOfPeriodReportId: string;hypotheticalWaterfallId: string}> = (props) => {
          const {fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId} = props ?? {};

          return  hypotheticalWaterfallDraftToComplete(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type HypotheticalWaterfallDraftToCompleteMutationResult = NonNullable<Awaited<ReturnType<typeof hypotheticalWaterfallDraftToComplete>>>
    
    export type HypotheticalWaterfallDraftToCompleteMutationError = unknown

    export const useHypotheticalWaterfallDraftToComplete = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hypotheticalWaterfallDraftToComplete>>, TError,{fundFamilyId: string;endOfPeriodReportId: string;hypotheticalWaterfallId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getHypotheticalWaterfallDraftToCompleteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Gets a hypothetical waterfall breakdown
 */
export const fundHypotheticalWaterfallCarryClawbackRetrieve = (
    fundFamilyId: string,
    endOfPeriodReportId: string,
    hypotheticalWaterfallId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<FundHypotheticalProtectedClawbackInfoDataByFund>(
      {url: `/fund-family/${fundFamilyId}/financial-reporting/${endOfPeriodReportId}/hypothetical-waterfall/${hypotheticalWaterfallId}/fund-clawback`, method: 'GET', signal
    },
      options);
    }
  

export const getFundHypotheticalWaterfallCarryClawbackRetrieveQueryKey = (fundFamilyId: string,
    endOfPeriodReportId: string,
    hypotheticalWaterfallId: string,) => {
    return [`/fund-family/${fundFamilyId}/financial-reporting/${endOfPeriodReportId}/hypothetical-waterfall/${hypotheticalWaterfallId}/fund-clawback`] as const;
    }

    
export const getFundHypotheticalWaterfallCarryClawbackRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof fundHypotheticalWaterfallCarryClawbackRetrieve>>, TError = unknown>(fundFamilyId: string,
    endOfPeriodReportId: string,
    hypotheticalWaterfallId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fundHypotheticalWaterfallCarryClawbackRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFundHypotheticalWaterfallCarryClawbackRetrieveQueryKey(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fundHypotheticalWaterfallCarryClawbackRetrieve>>> = ({ signal }) => fundHypotheticalWaterfallCarryClawbackRetrieve(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && endOfPeriodReportId && hypotheticalWaterfallId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fundHypotheticalWaterfallCarryClawbackRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FundHypotheticalWaterfallCarryClawbackRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof fundHypotheticalWaterfallCarryClawbackRetrieve>>>
export type FundHypotheticalWaterfallCarryClawbackRetrieveQueryError = unknown

export const useFundHypotheticalWaterfallCarryClawbackRetrieve = <TData = Awaited<ReturnType<typeof fundHypotheticalWaterfallCarryClawbackRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    endOfPeriodReportId: string,
    hypotheticalWaterfallId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fundHypotheticalWaterfallCarryClawbackRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFundHypotheticalWaterfallCarryClawbackRetrieveQueryOptions(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getFundHypotheticalWaterfallCarryClawbackRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof fundHypotheticalWaterfallCarryClawbackRetrieve>>, TError = unknown>(fundFamilyId: string,
    endOfPeriodReportId: string,
    hypotheticalWaterfallId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundHypotheticalWaterfallCarryClawbackRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFundHypotheticalWaterfallCarryClawbackRetrieveQueryKey(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fundHypotheticalWaterfallCarryClawbackRetrieve>>> = ({ signal }) => fundHypotheticalWaterfallCarryClawbackRetrieve(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && endOfPeriodReportId && hypotheticalWaterfallId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundHypotheticalWaterfallCarryClawbackRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FundHypotheticalWaterfallCarryClawbackRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof fundHypotheticalWaterfallCarryClawbackRetrieve>>>
export type FundHypotheticalWaterfallCarryClawbackRetrieveSuspenseQueryError = unknown

export const useFundHypotheticalWaterfallCarryClawbackRetrieveSuspense = <TData = Awaited<ReturnType<typeof fundHypotheticalWaterfallCarryClawbackRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    endOfPeriodReportId: string,
    hypotheticalWaterfallId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundHypotheticalWaterfallCarryClawbackRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFundHypotheticalWaterfallCarryClawbackRetrieveSuspenseQueryOptions(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getFundHypotheticalWaterfallCarryClawbackRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,endOfPeriodReportId: string,hypotheticalWaterfallId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && endOfPeriodReportId && hypotheticalWaterfallId) {
            return appQueryClient.prefetchQuery({
              queryKey: getFundHypotheticalWaterfallCarryClawbackRetrieveQueryKey(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId),
              queryFn: () => fundHypotheticalWaterfallCarryClawbackRetrieve(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Gets hypothetical waterfall fund performance details
 */
export const hypotheticalWaterfallFundPerformanceDetailsRetrieve = (
    fundFamilyId: string,
    endOfPeriodReportId: string,
    hypotheticalWaterfallId: string,
    params?: HypotheticalWaterfallFundPerformanceDetailsRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<HypotheticalFundDetailsData>(
      {url: `/fund-family/${fundFamilyId}/financial-reporting/${endOfPeriodReportId}/hypothetical-waterfall/${hypotheticalWaterfallId}/fund-performance-details`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getHypotheticalWaterfallFundPerformanceDetailsRetrieveQueryKey = (fundFamilyId: string,
    endOfPeriodReportId: string,
    hypotheticalWaterfallId: string,
    params?: HypotheticalWaterfallFundPerformanceDetailsRetrieveParams,) => {
    return [`/fund-family/${fundFamilyId}/financial-reporting/${endOfPeriodReportId}/hypothetical-waterfall/${hypotheticalWaterfallId}/fund-performance-details`, ...(params ? [params]: [])] as const;
    }

    
export const getHypotheticalWaterfallFundPerformanceDetailsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallFundPerformanceDetailsRetrieve>>, TError = unknown>(fundFamilyId: string,
    endOfPeriodReportId: string,
    hypotheticalWaterfallId: string,
    params?: HypotheticalWaterfallFundPerformanceDetailsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallFundPerformanceDetailsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHypotheticalWaterfallFundPerformanceDetailsRetrieveQueryKey(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof hypotheticalWaterfallFundPerformanceDetailsRetrieve>>> = ({ signal }) => hypotheticalWaterfallFundPerformanceDetailsRetrieve(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && endOfPeriodReportId && hypotheticalWaterfallId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallFundPerformanceDetailsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type HypotheticalWaterfallFundPerformanceDetailsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof hypotheticalWaterfallFundPerformanceDetailsRetrieve>>>
export type HypotheticalWaterfallFundPerformanceDetailsRetrieveQueryError = unknown

export const useHypotheticalWaterfallFundPerformanceDetailsRetrieve = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallFundPerformanceDetailsRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    endOfPeriodReportId: string,
    hypotheticalWaterfallId: string,
    params?: HypotheticalWaterfallFundPerformanceDetailsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallFundPerformanceDetailsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getHypotheticalWaterfallFundPerformanceDetailsRetrieveQueryOptions(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getHypotheticalWaterfallFundPerformanceDetailsRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallFundPerformanceDetailsRetrieve>>, TError = unknown>(fundFamilyId: string,
    endOfPeriodReportId: string,
    hypotheticalWaterfallId: string,
    params?: HypotheticalWaterfallFundPerformanceDetailsRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallFundPerformanceDetailsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHypotheticalWaterfallFundPerformanceDetailsRetrieveQueryKey(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof hypotheticalWaterfallFundPerformanceDetailsRetrieve>>> = ({ signal }) => hypotheticalWaterfallFundPerformanceDetailsRetrieve(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && endOfPeriodReportId && hypotheticalWaterfallId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallFundPerformanceDetailsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type HypotheticalWaterfallFundPerformanceDetailsRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof hypotheticalWaterfallFundPerformanceDetailsRetrieve>>>
export type HypotheticalWaterfallFundPerformanceDetailsRetrieveSuspenseQueryError = unknown

export const useHypotheticalWaterfallFundPerformanceDetailsRetrieveSuspense = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallFundPerformanceDetailsRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    endOfPeriodReportId: string,
    hypotheticalWaterfallId: string,
    params?: HypotheticalWaterfallFundPerformanceDetailsRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallFundPerformanceDetailsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getHypotheticalWaterfallFundPerformanceDetailsRetrieveSuspenseQueryOptions(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getHypotheticalWaterfallFundPerformanceDetailsRetrieveLoader = (queryParamsOrFn?: (HypotheticalWaterfallFundPerformanceDetailsRetrieveParams | ((params: Params) => HypotheticalWaterfallFundPerformanceDetailsRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,endOfPeriodReportId: string,hypotheticalWaterfallId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId && endOfPeriodReportId && hypotheticalWaterfallId) {
            return appQueryClient.prefetchQuery({
              queryKey: getHypotheticalWaterfallFundPerformanceDetailsRetrieveQueryKey(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId, queryParams),
              queryFn: () => hypotheticalWaterfallFundPerformanceDetailsRetrieve(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Gets the hypothetical waterfall net and gross IRR breakdowns
 */
export const hypotheticalWaterfallIRRBreakdownRetrieve = (
    fundFamilyId: string,
    endOfPeriodReportId: string,
    hypotheticalWaterfallId: string,
    params?: HypotheticalWaterfallIRRBreakdownRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<IRRBreakdownAPIData>(
      {url: `/fund-family/${fundFamilyId}/financial-reporting/${endOfPeriodReportId}/hypothetical-waterfall/${hypotheticalWaterfallId}/irr-breakdown`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getHypotheticalWaterfallIRRBreakdownRetrieveQueryKey = (fundFamilyId: string,
    endOfPeriodReportId: string,
    hypotheticalWaterfallId: string,
    params?: HypotheticalWaterfallIRRBreakdownRetrieveParams,) => {
    return [`/fund-family/${fundFamilyId}/financial-reporting/${endOfPeriodReportId}/hypothetical-waterfall/${hypotheticalWaterfallId}/irr-breakdown`, ...(params ? [params]: [])] as const;
    }

    
export const getHypotheticalWaterfallIRRBreakdownRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallIRRBreakdownRetrieve>>, TError = unknown>(fundFamilyId: string,
    endOfPeriodReportId: string,
    hypotheticalWaterfallId: string,
    params?: HypotheticalWaterfallIRRBreakdownRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallIRRBreakdownRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHypotheticalWaterfallIRRBreakdownRetrieveQueryKey(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof hypotheticalWaterfallIRRBreakdownRetrieve>>> = ({ signal }) => hypotheticalWaterfallIRRBreakdownRetrieve(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && endOfPeriodReportId && hypotheticalWaterfallId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallIRRBreakdownRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type HypotheticalWaterfallIRRBreakdownRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof hypotheticalWaterfallIRRBreakdownRetrieve>>>
export type HypotheticalWaterfallIRRBreakdownRetrieveQueryError = unknown

export const useHypotheticalWaterfallIRRBreakdownRetrieve = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallIRRBreakdownRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    endOfPeriodReportId: string,
    hypotheticalWaterfallId: string,
    params?: HypotheticalWaterfallIRRBreakdownRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallIRRBreakdownRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getHypotheticalWaterfallIRRBreakdownRetrieveQueryOptions(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getHypotheticalWaterfallIRRBreakdownRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallIRRBreakdownRetrieve>>, TError = unknown>(fundFamilyId: string,
    endOfPeriodReportId: string,
    hypotheticalWaterfallId: string,
    params?: HypotheticalWaterfallIRRBreakdownRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallIRRBreakdownRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHypotheticalWaterfallIRRBreakdownRetrieveQueryKey(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof hypotheticalWaterfallIRRBreakdownRetrieve>>> = ({ signal }) => hypotheticalWaterfallIRRBreakdownRetrieve(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && endOfPeriodReportId && hypotheticalWaterfallId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallIRRBreakdownRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type HypotheticalWaterfallIRRBreakdownRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof hypotheticalWaterfallIRRBreakdownRetrieve>>>
export type HypotheticalWaterfallIRRBreakdownRetrieveSuspenseQueryError = unknown

export const useHypotheticalWaterfallIRRBreakdownRetrieveSuspense = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallIRRBreakdownRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    endOfPeriodReportId: string,
    hypotheticalWaterfallId: string,
    params?: HypotheticalWaterfallIRRBreakdownRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallIRRBreakdownRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getHypotheticalWaterfallIRRBreakdownRetrieveSuspenseQueryOptions(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getHypotheticalWaterfallIRRBreakdownRetrieveLoader = (queryParamsOrFn?: (HypotheticalWaterfallIRRBreakdownRetrieveParams | ((params: Params) => HypotheticalWaterfallIRRBreakdownRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,endOfPeriodReportId: string,hypotheticalWaterfallId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId && endOfPeriodReportId && hypotheticalWaterfallId) {
            return appQueryClient.prefetchQuery({
              queryKey: getHypotheticalWaterfallIRRBreakdownRetrieveQueryKey(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId, queryParams),
              queryFn: () => hypotheticalWaterfallIRRBreakdownRetrieve(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Gets a hypothetical waterfall NAV breakdown
 */
export const hypotheticalWaterfallNavBreakdownRetrieve = (
    fundFamilyId: string,
    endOfPeriodReportId: string,
    hypotheticalWaterfallId: string,
    params?: HypotheticalWaterfallNavBreakdownRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<HypotheticalWaterfallNAVBreakdownAPIData>(
      {url: `/fund-family/${fundFamilyId}/financial-reporting/${endOfPeriodReportId}/hypothetical-waterfall/${hypotheticalWaterfallId}/nav-details`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getHypotheticalWaterfallNavBreakdownRetrieveQueryKey = (fundFamilyId: string,
    endOfPeriodReportId: string,
    hypotheticalWaterfallId: string,
    params?: HypotheticalWaterfallNavBreakdownRetrieveParams,) => {
    return [`/fund-family/${fundFamilyId}/financial-reporting/${endOfPeriodReportId}/hypothetical-waterfall/${hypotheticalWaterfallId}/nav-details`, ...(params ? [params]: [])] as const;
    }

    
export const getHypotheticalWaterfallNavBreakdownRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallNavBreakdownRetrieve>>, TError = unknown>(fundFamilyId: string,
    endOfPeriodReportId: string,
    hypotheticalWaterfallId: string,
    params?: HypotheticalWaterfallNavBreakdownRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallNavBreakdownRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHypotheticalWaterfallNavBreakdownRetrieveQueryKey(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof hypotheticalWaterfallNavBreakdownRetrieve>>> = ({ signal }) => hypotheticalWaterfallNavBreakdownRetrieve(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && endOfPeriodReportId && hypotheticalWaterfallId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallNavBreakdownRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type HypotheticalWaterfallNavBreakdownRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof hypotheticalWaterfallNavBreakdownRetrieve>>>
export type HypotheticalWaterfallNavBreakdownRetrieveQueryError = unknown

export const useHypotheticalWaterfallNavBreakdownRetrieve = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallNavBreakdownRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    endOfPeriodReportId: string,
    hypotheticalWaterfallId: string,
    params?: HypotheticalWaterfallNavBreakdownRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallNavBreakdownRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getHypotheticalWaterfallNavBreakdownRetrieveQueryOptions(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getHypotheticalWaterfallNavBreakdownRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallNavBreakdownRetrieve>>, TError = unknown>(fundFamilyId: string,
    endOfPeriodReportId: string,
    hypotheticalWaterfallId: string,
    params?: HypotheticalWaterfallNavBreakdownRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallNavBreakdownRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHypotheticalWaterfallNavBreakdownRetrieveQueryKey(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof hypotheticalWaterfallNavBreakdownRetrieve>>> = ({ signal }) => hypotheticalWaterfallNavBreakdownRetrieve(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && endOfPeriodReportId && hypotheticalWaterfallId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallNavBreakdownRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type HypotheticalWaterfallNavBreakdownRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof hypotheticalWaterfallNavBreakdownRetrieve>>>
export type HypotheticalWaterfallNavBreakdownRetrieveSuspenseQueryError = unknown

export const useHypotheticalWaterfallNavBreakdownRetrieveSuspense = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallNavBreakdownRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    endOfPeriodReportId: string,
    hypotheticalWaterfallId: string,
    params?: HypotheticalWaterfallNavBreakdownRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallNavBreakdownRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getHypotheticalWaterfallNavBreakdownRetrieveSuspenseQueryOptions(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getHypotheticalWaterfallNavBreakdownRetrieveLoader = (queryParamsOrFn?: (HypotheticalWaterfallNavBreakdownRetrieveParams | ((params: Params) => HypotheticalWaterfallNavBreakdownRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,endOfPeriodReportId: string,hypotheticalWaterfallId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId && endOfPeriodReportId && hypotheticalWaterfallId) {
            return appQueryClient.prefetchQuery({
              queryKey: getHypotheticalWaterfallNavBreakdownRetrieveQueryKey(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId, queryParams),
              queryFn: () => hypotheticalWaterfallNavBreakdownRetrieve(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Gets hypothetical waterfall performance
 */
export const hypotheticalWaterfallPerformanceBreakdownRetrieve = (
    fundFamilyId: string,
    endOfPeriodReportId: string,
    hypotheticalWaterfallId: string,
    params?: HypotheticalWaterfallPerformanceBreakdownRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<HypotheticalWaterfallPerformanceBreakdownAPIData>(
      {url: `/fund-family/${fundFamilyId}/financial-reporting/${endOfPeriodReportId}/hypothetical-waterfall/${hypotheticalWaterfallId}/performance-breakdown`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getHypotheticalWaterfallPerformanceBreakdownRetrieveQueryKey = (fundFamilyId: string,
    endOfPeriodReportId: string,
    hypotheticalWaterfallId: string,
    params?: HypotheticalWaterfallPerformanceBreakdownRetrieveParams,) => {
    return [`/fund-family/${fundFamilyId}/financial-reporting/${endOfPeriodReportId}/hypothetical-waterfall/${hypotheticalWaterfallId}/performance-breakdown`, ...(params ? [params]: [])] as const;
    }

    
export const getHypotheticalWaterfallPerformanceBreakdownRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallPerformanceBreakdownRetrieve>>, TError = unknown>(fundFamilyId: string,
    endOfPeriodReportId: string,
    hypotheticalWaterfallId: string,
    params?: HypotheticalWaterfallPerformanceBreakdownRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallPerformanceBreakdownRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHypotheticalWaterfallPerformanceBreakdownRetrieveQueryKey(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof hypotheticalWaterfallPerformanceBreakdownRetrieve>>> = ({ signal }) => hypotheticalWaterfallPerformanceBreakdownRetrieve(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && endOfPeriodReportId && hypotheticalWaterfallId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallPerformanceBreakdownRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type HypotheticalWaterfallPerformanceBreakdownRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof hypotheticalWaterfallPerformanceBreakdownRetrieve>>>
export type HypotheticalWaterfallPerformanceBreakdownRetrieveQueryError = unknown

export const useHypotheticalWaterfallPerformanceBreakdownRetrieve = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallPerformanceBreakdownRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    endOfPeriodReportId: string,
    hypotheticalWaterfallId: string,
    params?: HypotheticalWaterfallPerformanceBreakdownRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallPerformanceBreakdownRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getHypotheticalWaterfallPerformanceBreakdownRetrieveQueryOptions(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getHypotheticalWaterfallPerformanceBreakdownRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallPerformanceBreakdownRetrieve>>, TError = unknown>(fundFamilyId: string,
    endOfPeriodReportId: string,
    hypotheticalWaterfallId: string,
    params?: HypotheticalWaterfallPerformanceBreakdownRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallPerformanceBreakdownRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHypotheticalWaterfallPerformanceBreakdownRetrieveQueryKey(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof hypotheticalWaterfallPerformanceBreakdownRetrieve>>> = ({ signal }) => hypotheticalWaterfallPerformanceBreakdownRetrieve(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && endOfPeriodReportId && hypotheticalWaterfallId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallPerformanceBreakdownRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type HypotheticalWaterfallPerformanceBreakdownRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof hypotheticalWaterfallPerformanceBreakdownRetrieve>>>
export type HypotheticalWaterfallPerformanceBreakdownRetrieveSuspenseQueryError = unknown

export const useHypotheticalWaterfallPerformanceBreakdownRetrieveSuspense = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallPerformanceBreakdownRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    endOfPeriodReportId: string,
    hypotheticalWaterfallId: string,
    params?: HypotheticalWaterfallPerformanceBreakdownRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallPerformanceBreakdownRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getHypotheticalWaterfallPerformanceBreakdownRetrieveSuspenseQueryOptions(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getHypotheticalWaterfallPerformanceBreakdownRetrieveLoader = (queryParamsOrFn?: (HypotheticalWaterfallPerformanceBreakdownRetrieveParams | ((params: Params) => HypotheticalWaterfallPerformanceBreakdownRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,endOfPeriodReportId: string,hypotheticalWaterfallId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId && endOfPeriodReportId && hypotheticalWaterfallId) {
            return appQueryClient.prefetchQuery({
              queryKey: getHypotheticalWaterfallPerformanceBreakdownRetrieveQueryKey(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId, queryParams),
              queryFn: () => hypotheticalWaterfallPerformanceBreakdownRetrieve(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Gets hypothetical waterfall performance multiples
 */
export const hypotheticalWaterfallPerformanceMultiplesRetrieve = (
    fundFamilyId: string,
    endOfPeriodReportId: string,
    hypotheticalWaterfallId: string,
    params?: HypotheticalWaterfallPerformanceMultiplesRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<HypotheticalWaterfallPerformanceMultiplesAPIData>(
      {url: `/fund-family/${fundFamilyId}/financial-reporting/${endOfPeriodReportId}/hypothetical-waterfall/${hypotheticalWaterfallId}/performance-multiples`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getHypotheticalWaterfallPerformanceMultiplesRetrieveQueryKey = (fundFamilyId: string,
    endOfPeriodReportId: string,
    hypotheticalWaterfallId: string,
    params?: HypotheticalWaterfallPerformanceMultiplesRetrieveParams,) => {
    return [`/fund-family/${fundFamilyId}/financial-reporting/${endOfPeriodReportId}/hypothetical-waterfall/${hypotheticalWaterfallId}/performance-multiples`, ...(params ? [params]: [])] as const;
    }

    
export const getHypotheticalWaterfallPerformanceMultiplesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallPerformanceMultiplesRetrieve>>, TError = unknown>(fundFamilyId: string,
    endOfPeriodReportId: string,
    hypotheticalWaterfallId: string,
    params?: HypotheticalWaterfallPerformanceMultiplesRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallPerformanceMultiplesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHypotheticalWaterfallPerformanceMultiplesRetrieveQueryKey(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof hypotheticalWaterfallPerformanceMultiplesRetrieve>>> = ({ signal }) => hypotheticalWaterfallPerformanceMultiplesRetrieve(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && endOfPeriodReportId && hypotheticalWaterfallId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallPerformanceMultiplesRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type HypotheticalWaterfallPerformanceMultiplesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof hypotheticalWaterfallPerformanceMultiplesRetrieve>>>
export type HypotheticalWaterfallPerformanceMultiplesRetrieveQueryError = unknown

export const useHypotheticalWaterfallPerformanceMultiplesRetrieve = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallPerformanceMultiplesRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    endOfPeriodReportId: string,
    hypotheticalWaterfallId: string,
    params?: HypotheticalWaterfallPerformanceMultiplesRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallPerformanceMultiplesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getHypotheticalWaterfallPerformanceMultiplesRetrieveQueryOptions(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getHypotheticalWaterfallPerformanceMultiplesRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallPerformanceMultiplesRetrieve>>, TError = unknown>(fundFamilyId: string,
    endOfPeriodReportId: string,
    hypotheticalWaterfallId: string,
    params?: HypotheticalWaterfallPerformanceMultiplesRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallPerformanceMultiplesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHypotheticalWaterfallPerformanceMultiplesRetrieveQueryKey(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof hypotheticalWaterfallPerformanceMultiplesRetrieve>>> = ({ signal }) => hypotheticalWaterfallPerformanceMultiplesRetrieve(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && endOfPeriodReportId && hypotheticalWaterfallId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallPerformanceMultiplesRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type HypotheticalWaterfallPerformanceMultiplesRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof hypotheticalWaterfallPerformanceMultiplesRetrieve>>>
export type HypotheticalWaterfallPerformanceMultiplesRetrieveSuspenseQueryError = unknown

export const useHypotheticalWaterfallPerformanceMultiplesRetrieveSuspense = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallPerformanceMultiplesRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    endOfPeriodReportId: string,
    hypotheticalWaterfallId: string,
    params?: HypotheticalWaterfallPerformanceMultiplesRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallPerformanceMultiplesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getHypotheticalWaterfallPerformanceMultiplesRetrieveSuspenseQueryOptions(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getHypotheticalWaterfallPerformanceMultiplesRetrieveLoader = (queryParamsOrFn?: (HypotheticalWaterfallPerformanceMultiplesRetrieveParams | ((params: Params) => HypotheticalWaterfallPerformanceMultiplesRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,endOfPeriodReportId: string,hypotheticalWaterfallId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId && endOfPeriodReportId && hypotheticalWaterfallId) {
            return appQueryClient.prefetchQuery({
              queryKey: getHypotheticalWaterfallPerformanceMultiplesRetrieveQueryKey(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId, queryParams),
              queryFn: () => hypotheticalWaterfallPerformanceMultiplesRetrieve(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Get preferred return summary data for hypo
 */
export const hypotheticalWaterfallPreferredReturnSummaryRetrieve = (
    fundFamilyId: string,
    endOfPeriodReportId: string,
    hypotheticalWaterfallId: string,
    params: HypotheticalWaterfallPreferredReturnSummaryRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<HypotheticalWaterfallPreferredBreakdownAPIData>(
      {url: `/fund-family/${fundFamilyId}/financial-reporting/${endOfPeriodReportId}/hypothetical-waterfall/${hypotheticalWaterfallId}/pref-breakdown`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getHypotheticalWaterfallPreferredReturnSummaryRetrieveQueryKey = (fundFamilyId: string,
    endOfPeriodReportId: string,
    hypotheticalWaterfallId: string,
    params: HypotheticalWaterfallPreferredReturnSummaryRetrieveParams,) => {
    return [`/fund-family/${fundFamilyId}/financial-reporting/${endOfPeriodReportId}/hypothetical-waterfall/${hypotheticalWaterfallId}/pref-breakdown`, ...(params ? [params]: [])] as const;
    }

    
export const getHypotheticalWaterfallPreferredReturnSummaryRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallPreferredReturnSummaryRetrieve>>, TError = unknown>(fundFamilyId: string,
    endOfPeriodReportId: string,
    hypotheticalWaterfallId: string,
    params: HypotheticalWaterfallPreferredReturnSummaryRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallPreferredReturnSummaryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHypotheticalWaterfallPreferredReturnSummaryRetrieveQueryKey(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof hypotheticalWaterfallPreferredReturnSummaryRetrieve>>> = ({ signal }) => hypotheticalWaterfallPreferredReturnSummaryRetrieve(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && endOfPeriodReportId && hypotheticalWaterfallId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallPreferredReturnSummaryRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type HypotheticalWaterfallPreferredReturnSummaryRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof hypotheticalWaterfallPreferredReturnSummaryRetrieve>>>
export type HypotheticalWaterfallPreferredReturnSummaryRetrieveQueryError = unknown

export const useHypotheticalWaterfallPreferredReturnSummaryRetrieve = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallPreferredReturnSummaryRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    endOfPeriodReportId: string,
    hypotheticalWaterfallId: string,
    params: HypotheticalWaterfallPreferredReturnSummaryRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallPreferredReturnSummaryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getHypotheticalWaterfallPreferredReturnSummaryRetrieveQueryOptions(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getHypotheticalWaterfallPreferredReturnSummaryRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallPreferredReturnSummaryRetrieve>>, TError = unknown>(fundFamilyId: string,
    endOfPeriodReportId: string,
    hypotheticalWaterfallId: string,
    params: HypotheticalWaterfallPreferredReturnSummaryRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallPreferredReturnSummaryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHypotheticalWaterfallPreferredReturnSummaryRetrieveQueryKey(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof hypotheticalWaterfallPreferredReturnSummaryRetrieve>>> = ({ signal }) => hypotheticalWaterfallPreferredReturnSummaryRetrieve(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && endOfPeriodReportId && hypotheticalWaterfallId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallPreferredReturnSummaryRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type HypotheticalWaterfallPreferredReturnSummaryRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof hypotheticalWaterfallPreferredReturnSummaryRetrieve>>>
export type HypotheticalWaterfallPreferredReturnSummaryRetrieveSuspenseQueryError = unknown

export const useHypotheticalWaterfallPreferredReturnSummaryRetrieveSuspense = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallPreferredReturnSummaryRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    endOfPeriodReportId: string,
    hypotheticalWaterfallId: string,
    params: HypotheticalWaterfallPreferredReturnSummaryRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallPreferredReturnSummaryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getHypotheticalWaterfallPreferredReturnSummaryRetrieveSuspenseQueryOptions(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getHypotheticalWaterfallPreferredReturnSummaryRetrieveLoader = (queryParamsOrFn: (HypotheticalWaterfallPreferredReturnSummaryRetrieveParams | ((params: Params) => HypotheticalWaterfallPreferredReturnSummaryRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,endOfPeriodReportId: string,hypotheticalWaterfallId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId && endOfPeriodReportId && hypotheticalWaterfallId) {
            return appQueryClient.prefetchQuery({
              queryKey: getHypotheticalWaterfallPreferredReturnSummaryRetrieveQueryKey(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId, queryParams),
              queryFn: () => hypotheticalWaterfallPreferredReturnSummaryRetrieve(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Gets a hypothetical waterfall breakdown
 */
export const hypotheticalWaterfallDetailsBreakdownRetrieve = (
    fundFamilyId: string,
    endOfPeriodReportId: string,
    hypotheticalWaterfallId: string,
    params: HypotheticalWaterfallDetailsBreakdownRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<WaterfallDistributionData>(
      {url: `/fund-family/${fundFamilyId}/financial-reporting/${endOfPeriodReportId}/hypothetical-waterfall/${hypotheticalWaterfallId}/waterfall-details`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getHypotheticalWaterfallDetailsBreakdownRetrieveQueryKey = (fundFamilyId: string,
    endOfPeriodReportId: string,
    hypotheticalWaterfallId: string,
    params: HypotheticalWaterfallDetailsBreakdownRetrieveParams,) => {
    return [`/fund-family/${fundFamilyId}/financial-reporting/${endOfPeriodReportId}/hypothetical-waterfall/${hypotheticalWaterfallId}/waterfall-details`, ...(params ? [params]: [])] as const;
    }

    
export const getHypotheticalWaterfallDetailsBreakdownRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallDetailsBreakdownRetrieve>>, TError = unknown>(fundFamilyId: string,
    endOfPeriodReportId: string,
    hypotheticalWaterfallId: string,
    params: HypotheticalWaterfallDetailsBreakdownRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallDetailsBreakdownRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHypotheticalWaterfallDetailsBreakdownRetrieveQueryKey(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof hypotheticalWaterfallDetailsBreakdownRetrieve>>> = ({ signal }) => hypotheticalWaterfallDetailsBreakdownRetrieve(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && endOfPeriodReportId && hypotheticalWaterfallId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallDetailsBreakdownRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type HypotheticalWaterfallDetailsBreakdownRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof hypotheticalWaterfallDetailsBreakdownRetrieve>>>
export type HypotheticalWaterfallDetailsBreakdownRetrieveQueryError = unknown

export const useHypotheticalWaterfallDetailsBreakdownRetrieve = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallDetailsBreakdownRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    endOfPeriodReportId: string,
    hypotheticalWaterfallId: string,
    params: HypotheticalWaterfallDetailsBreakdownRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallDetailsBreakdownRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getHypotheticalWaterfallDetailsBreakdownRetrieveQueryOptions(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getHypotheticalWaterfallDetailsBreakdownRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallDetailsBreakdownRetrieve>>, TError = unknown>(fundFamilyId: string,
    endOfPeriodReportId: string,
    hypotheticalWaterfallId: string,
    params: HypotheticalWaterfallDetailsBreakdownRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallDetailsBreakdownRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHypotheticalWaterfallDetailsBreakdownRetrieveQueryKey(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof hypotheticalWaterfallDetailsBreakdownRetrieve>>> = ({ signal }) => hypotheticalWaterfallDetailsBreakdownRetrieve(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && endOfPeriodReportId && hypotheticalWaterfallId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallDetailsBreakdownRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type HypotheticalWaterfallDetailsBreakdownRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof hypotheticalWaterfallDetailsBreakdownRetrieve>>>
export type HypotheticalWaterfallDetailsBreakdownRetrieveSuspenseQueryError = unknown

export const useHypotheticalWaterfallDetailsBreakdownRetrieveSuspense = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallDetailsBreakdownRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    endOfPeriodReportId: string,
    hypotheticalWaterfallId: string,
    params: HypotheticalWaterfallDetailsBreakdownRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallDetailsBreakdownRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getHypotheticalWaterfallDetailsBreakdownRetrieveSuspenseQueryOptions(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getHypotheticalWaterfallDetailsBreakdownRetrieveLoader = (queryParamsOrFn: (HypotheticalWaterfallDetailsBreakdownRetrieveParams | ((params: Params) => HypotheticalWaterfallDetailsBreakdownRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,endOfPeriodReportId: string,hypotheticalWaterfallId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId && endOfPeriodReportId && hypotheticalWaterfallId) {
            return appQueryClient.prefetchQuery({
              queryKey: getHypotheticalWaterfallDetailsBreakdownRetrieveQueryKey(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId, queryParams),
              queryFn: () => hypotheticalWaterfallDetailsBreakdownRetrieve(fundFamilyId,endOfPeriodReportId,hypotheticalWaterfallId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Get capital activity breakdown data by entity
 */
export const hypotheticalWaterfallCapitalActivityDataRetrieve = (
    fundFamilyId: string,
    params?: HypotheticalWaterfallCapitalActivityDataRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<HypotheticalWaterfallCapitalActivityBreakdownAPIData>(
      {url: `/fund-family/${fundFamilyId}/financial-reporting/capital-activity-breakdown`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getHypotheticalWaterfallCapitalActivityDataRetrieveQueryKey = (fundFamilyId: string,
    params?: HypotheticalWaterfallCapitalActivityDataRetrieveParams,) => {
    return [`/fund-family/${fundFamilyId}/financial-reporting/capital-activity-breakdown`, ...(params ? [params]: [])] as const;
    }

    
export const getHypotheticalWaterfallCapitalActivityDataRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallCapitalActivityDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    params?: HypotheticalWaterfallCapitalActivityDataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallCapitalActivityDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHypotheticalWaterfallCapitalActivityDataRetrieveQueryKey(fundFamilyId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof hypotheticalWaterfallCapitalActivityDataRetrieve>>> = ({ signal }) => hypotheticalWaterfallCapitalActivityDataRetrieve(fundFamilyId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallCapitalActivityDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type HypotheticalWaterfallCapitalActivityDataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof hypotheticalWaterfallCapitalActivityDataRetrieve>>>
export type HypotheticalWaterfallCapitalActivityDataRetrieveQueryError = unknown

export const useHypotheticalWaterfallCapitalActivityDataRetrieve = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallCapitalActivityDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    params?: HypotheticalWaterfallCapitalActivityDataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallCapitalActivityDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getHypotheticalWaterfallCapitalActivityDataRetrieveQueryOptions(fundFamilyId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getHypotheticalWaterfallCapitalActivityDataRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallCapitalActivityDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    params?: HypotheticalWaterfallCapitalActivityDataRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallCapitalActivityDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHypotheticalWaterfallCapitalActivityDataRetrieveQueryKey(fundFamilyId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof hypotheticalWaterfallCapitalActivityDataRetrieve>>> = ({ signal }) => hypotheticalWaterfallCapitalActivityDataRetrieve(fundFamilyId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallCapitalActivityDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type HypotheticalWaterfallCapitalActivityDataRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof hypotheticalWaterfallCapitalActivityDataRetrieve>>>
export type HypotheticalWaterfallCapitalActivityDataRetrieveSuspenseQueryError = unknown

export const useHypotheticalWaterfallCapitalActivityDataRetrieveSuspense = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallCapitalActivityDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    params?: HypotheticalWaterfallCapitalActivityDataRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallCapitalActivityDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getHypotheticalWaterfallCapitalActivityDataRetrieveSuspenseQueryOptions(fundFamilyId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getHypotheticalWaterfallCapitalActivityDataRetrieveLoader = (queryParamsOrFn?: (HypotheticalWaterfallCapitalActivityDataRetrieveParams | ((params: Params) => HypotheticalWaterfallCapitalActivityDataRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId) {
            return appQueryClient.prefetchQuery({
              queryKey: getHypotheticalWaterfallCapitalActivityDataRetrieveQueryKey(fundFamilyId, queryParams),
              queryFn: () => hypotheticalWaterfallCapitalActivityDataRetrieve(fundFamilyId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Gets whether or not financial reporting is configured for a fund family.
 */
export const financialReportingConfigurationStatusRetrieve = (
    fundFamilyId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<FinancialReportingConfigurationStatus>(
      {url: `/fund-family/${fundFamilyId}/financial-reporting/configuration/status`, method: 'GET', signal
    },
      options);
    }
  

export const getFinancialReportingConfigurationStatusRetrieveQueryKey = (fundFamilyId: string,) => {
    return [`/fund-family/${fundFamilyId}/financial-reporting/configuration/status`] as const;
    }

    
export const getFinancialReportingConfigurationStatusRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof financialReportingConfigurationStatusRetrieve>>, TError = unknown>(fundFamilyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof financialReportingConfigurationStatusRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFinancialReportingConfigurationStatusRetrieveQueryKey(fundFamilyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof financialReportingConfigurationStatusRetrieve>>> = ({ signal }) => financialReportingConfigurationStatusRetrieve(fundFamilyId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof financialReportingConfigurationStatusRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FinancialReportingConfigurationStatusRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof financialReportingConfigurationStatusRetrieve>>>
export type FinancialReportingConfigurationStatusRetrieveQueryError = unknown

export const useFinancialReportingConfigurationStatusRetrieve = <TData = Awaited<ReturnType<typeof financialReportingConfigurationStatusRetrieve>>, TError = unknown>(
 fundFamilyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof financialReportingConfigurationStatusRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFinancialReportingConfigurationStatusRetrieveQueryOptions(fundFamilyId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getFinancialReportingConfigurationStatusRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof financialReportingConfigurationStatusRetrieve>>, TError = unknown>(fundFamilyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof financialReportingConfigurationStatusRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFinancialReportingConfigurationStatusRetrieveQueryKey(fundFamilyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof financialReportingConfigurationStatusRetrieve>>> = ({ signal }) => financialReportingConfigurationStatusRetrieve(fundFamilyId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof financialReportingConfigurationStatusRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FinancialReportingConfigurationStatusRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof financialReportingConfigurationStatusRetrieve>>>
export type FinancialReportingConfigurationStatusRetrieveSuspenseQueryError = unknown

export const useFinancialReportingConfigurationStatusRetrieveSuspense = <TData = Awaited<ReturnType<typeof financialReportingConfigurationStatusRetrieve>>, TError = unknown>(
 fundFamilyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof financialReportingConfigurationStatusRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFinancialReportingConfigurationStatusRetrieveSuspenseQueryOptions(fundFamilyId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getFinancialReportingConfigurationStatusRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId) {
            return appQueryClient.prefetchQuery({
              queryKey: getFinancialReportingConfigurationStatusRetrieveQueryKey(fundFamilyId),
              queryFn: () => financialReportingConfigurationStatusRetrieve(fundFamilyId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * List of funds available for hypothetical waterfall
 */
export const hypotheticalWaterfallAvailableFundsList = (
    fundFamilyId: string,
    hypotheticalWaterfallId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<FundEntityReadDataList>(
      {url: `/fund-family/${fundFamilyId}/financial-reporting/hypothetical-waterfall/${hypotheticalWaterfallId}/available-funds`, method: 'GET', signal
    },
      options);
    }
  

export const getHypotheticalWaterfallAvailableFundsListQueryKey = (fundFamilyId: string,
    hypotheticalWaterfallId: string,) => {
    return [`/fund-family/${fundFamilyId}/financial-reporting/hypothetical-waterfall/${hypotheticalWaterfallId}/available-funds`] as const;
    }

    
export const getHypotheticalWaterfallAvailableFundsListQueryOptions = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallAvailableFundsList>>, TError = unknown>(fundFamilyId: string,
    hypotheticalWaterfallId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallAvailableFundsList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHypotheticalWaterfallAvailableFundsListQueryKey(fundFamilyId,hypotheticalWaterfallId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof hypotheticalWaterfallAvailableFundsList>>> = ({ signal }) => hypotheticalWaterfallAvailableFundsList(fundFamilyId,hypotheticalWaterfallId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && hypotheticalWaterfallId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallAvailableFundsList>>, TError, TData> & { queryKey: QueryKey }
}

export type HypotheticalWaterfallAvailableFundsListQueryResult = NonNullable<Awaited<ReturnType<typeof hypotheticalWaterfallAvailableFundsList>>>
export type HypotheticalWaterfallAvailableFundsListQueryError = unknown

export const useHypotheticalWaterfallAvailableFundsList = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallAvailableFundsList>>, TError = unknown>(
 fundFamilyId: string,
    hypotheticalWaterfallId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallAvailableFundsList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getHypotheticalWaterfallAvailableFundsListQueryOptions(fundFamilyId,hypotheticalWaterfallId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getHypotheticalWaterfallAvailableFundsListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallAvailableFundsList>>, TError = unknown>(fundFamilyId: string,
    hypotheticalWaterfallId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallAvailableFundsList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHypotheticalWaterfallAvailableFundsListQueryKey(fundFamilyId,hypotheticalWaterfallId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof hypotheticalWaterfallAvailableFundsList>>> = ({ signal }) => hypotheticalWaterfallAvailableFundsList(fundFamilyId,hypotheticalWaterfallId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && hypotheticalWaterfallId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallAvailableFundsList>>, TError, TData> & { queryKey: QueryKey }
}

export type HypotheticalWaterfallAvailableFundsListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof hypotheticalWaterfallAvailableFundsList>>>
export type HypotheticalWaterfallAvailableFundsListSuspenseQueryError = unknown

export const useHypotheticalWaterfallAvailableFundsListSuspense = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallAvailableFundsList>>, TError = unknown>(
 fundFamilyId: string,
    hypotheticalWaterfallId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallAvailableFundsList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getHypotheticalWaterfallAvailableFundsListSuspenseQueryOptions(fundFamilyId,hypotheticalWaterfallId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getHypotheticalWaterfallAvailableFundsListLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,hypotheticalWaterfallId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,hypotheticalWaterfallId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && hypotheticalWaterfallId) {
            return appQueryClient.prefetchQuery({
              queryKey: getHypotheticalWaterfallAvailableFundsListQueryKey(fundFamilyId,hypotheticalWaterfallId),
              queryFn: () => hypotheticalWaterfallAvailableFundsList(fundFamilyId,hypotheticalWaterfallId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Chart Data representing fund family NAV over time
 */
export const fundFamilySummaryNavChartRetrieve = (
    fundFamilyId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericChartData>(
      {url: `/fund-family/${fundFamilyId}/financial-reporting/summary/nav`, method: 'GET', signal
    },
      options);
    }
  

export const getFundFamilySummaryNavChartRetrieveQueryKey = (fundFamilyId: string,) => {
    return [`/fund-family/${fundFamilyId}/financial-reporting/summary/nav`] as const;
    }

    
export const getFundFamilySummaryNavChartRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof fundFamilySummaryNavChartRetrieve>>, TError = unknown>(fundFamilyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fundFamilySummaryNavChartRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFundFamilySummaryNavChartRetrieveQueryKey(fundFamilyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fundFamilySummaryNavChartRetrieve>>> = ({ signal }) => fundFamilySummaryNavChartRetrieve(fundFamilyId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fundFamilySummaryNavChartRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FundFamilySummaryNavChartRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof fundFamilySummaryNavChartRetrieve>>>
export type FundFamilySummaryNavChartRetrieveQueryError = unknown

export const useFundFamilySummaryNavChartRetrieve = <TData = Awaited<ReturnType<typeof fundFamilySummaryNavChartRetrieve>>, TError = unknown>(
 fundFamilyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fundFamilySummaryNavChartRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFundFamilySummaryNavChartRetrieveQueryOptions(fundFamilyId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getFundFamilySummaryNavChartRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof fundFamilySummaryNavChartRetrieve>>, TError = unknown>(fundFamilyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundFamilySummaryNavChartRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFundFamilySummaryNavChartRetrieveQueryKey(fundFamilyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fundFamilySummaryNavChartRetrieve>>> = ({ signal }) => fundFamilySummaryNavChartRetrieve(fundFamilyId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundFamilySummaryNavChartRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FundFamilySummaryNavChartRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof fundFamilySummaryNavChartRetrieve>>>
export type FundFamilySummaryNavChartRetrieveSuspenseQueryError = unknown

export const useFundFamilySummaryNavChartRetrieveSuspense = <TData = Awaited<ReturnType<typeof fundFamilySummaryNavChartRetrieve>>, TError = unknown>(
 fundFamilyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundFamilySummaryNavChartRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFundFamilySummaryNavChartRetrieveSuspenseQueryOptions(fundFamilyId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getFundFamilySummaryNavChartRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId) {
            return appQueryClient.prefetchQuery({
              queryKey: getFundFamilySummaryNavChartRetrieveQueryKey(fundFamilyId),
              queryFn: () => fundFamilySummaryNavChartRetrieve(fundFamilyId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Chart Data representing fund family IRRs over time
 */
export const fundFamilySummaryPerformanceChartRetrieve = (
    fundFamilyId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericChartData>(
      {url: `/fund-family/${fundFamilyId}/financial-reporting/summary/performance`, method: 'GET', signal
    },
      options);
    }
  

export const getFundFamilySummaryPerformanceChartRetrieveQueryKey = (fundFamilyId: string,) => {
    return [`/fund-family/${fundFamilyId}/financial-reporting/summary/performance`] as const;
    }

    
export const getFundFamilySummaryPerformanceChartRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof fundFamilySummaryPerformanceChartRetrieve>>, TError = unknown>(fundFamilyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fundFamilySummaryPerformanceChartRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFundFamilySummaryPerformanceChartRetrieveQueryKey(fundFamilyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fundFamilySummaryPerformanceChartRetrieve>>> = ({ signal }) => fundFamilySummaryPerformanceChartRetrieve(fundFamilyId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fundFamilySummaryPerformanceChartRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FundFamilySummaryPerformanceChartRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof fundFamilySummaryPerformanceChartRetrieve>>>
export type FundFamilySummaryPerformanceChartRetrieveQueryError = unknown

export const useFundFamilySummaryPerformanceChartRetrieve = <TData = Awaited<ReturnType<typeof fundFamilySummaryPerformanceChartRetrieve>>, TError = unknown>(
 fundFamilyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fundFamilySummaryPerformanceChartRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFundFamilySummaryPerformanceChartRetrieveQueryOptions(fundFamilyId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getFundFamilySummaryPerformanceChartRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof fundFamilySummaryPerformanceChartRetrieve>>, TError = unknown>(fundFamilyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundFamilySummaryPerformanceChartRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFundFamilySummaryPerformanceChartRetrieveQueryKey(fundFamilyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fundFamilySummaryPerformanceChartRetrieve>>> = ({ signal }) => fundFamilySummaryPerformanceChartRetrieve(fundFamilyId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundFamilySummaryPerformanceChartRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FundFamilySummaryPerformanceChartRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof fundFamilySummaryPerformanceChartRetrieve>>>
export type FundFamilySummaryPerformanceChartRetrieveSuspenseQueryError = unknown

export const useFundFamilySummaryPerformanceChartRetrieveSuspense = <TData = Awaited<ReturnType<typeof fundFamilySummaryPerformanceChartRetrieve>>, TError = unknown>(
 fundFamilyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundFamilySummaryPerformanceChartRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFundFamilySummaryPerformanceChartRetrieveSuspenseQueryOptions(fundFamilyId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getFundFamilySummaryPerformanceChartRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId) {
            return appQueryClient.prefetchQuery({
              queryKey: getFundFamilySummaryPerformanceChartRetrieveQueryKey(fundFamilyId),
              queryFn: () => fundFamilySummaryPerformanceChartRetrieve(fundFamilyId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Get hypothetical table input data
 */
export const hypotheticalWaterfallDataRetrieve = (
    fundFamilyId: string,
    params?: HypotheticalWaterfallDataRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<FundFamilyUseAllocationTableDataWithDefinition>(
      {url: `/fund-family/${fundFamilyId}/financial-reporting/table-data`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getHypotheticalWaterfallDataRetrieveQueryKey = (fundFamilyId: string,
    params?: HypotheticalWaterfallDataRetrieveParams,) => {
    return [`/fund-family/${fundFamilyId}/financial-reporting/table-data`, ...(params ? [params]: [])] as const;
    }

    
export const getHypotheticalWaterfallDataRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    params?: HypotheticalWaterfallDataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHypotheticalWaterfallDataRetrieveQueryKey(fundFamilyId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof hypotheticalWaterfallDataRetrieve>>> = ({ signal }) => hypotheticalWaterfallDataRetrieve(fundFamilyId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type HypotheticalWaterfallDataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof hypotheticalWaterfallDataRetrieve>>>
export type HypotheticalWaterfallDataRetrieveQueryError = unknown

export const useHypotheticalWaterfallDataRetrieve = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    params?: HypotheticalWaterfallDataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getHypotheticalWaterfallDataRetrieveQueryOptions(fundFamilyId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getHypotheticalWaterfallDataRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    params?: HypotheticalWaterfallDataRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHypotheticalWaterfallDataRetrieveQueryKey(fundFamilyId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof hypotheticalWaterfallDataRetrieve>>> = ({ signal }) => hypotheticalWaterfallDataRetrieve(fundFamilyId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type HypotheticalWaterfallDataRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof hypotheticalWaterfallDataRetrieve>>>
export type HypotheticalWaterfallDataRetrieveSuspenseQueryError = unknown

export const useHypotheticalWaterfallDataRetrieveSuspense = <TData = Awaited<ReturnType<typeof hypotheticalWaterfallDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    params?: HypotheticalWaterfallDataRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof hypotheticalWaterfallDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getHypotheticalWaterfallDataRetrieveSuspenseQueryOptions(fundFamilyId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getHypotheticalWaterfallDataRetrieveLoader = (queryParamsOrFn?: (HypotheticalWaterfallDataRetrieveParams | ((params: Params) => HypotheticalWaterfallDataRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId) {
            return appQueryClient.prefetchQuery({
              queryKey: getHypotheticalWaterfallDataRetrieveQueryKey(fundFamilyId, queryParams),
              queryFn: () => hypotheticalWaterfallDataRetrieve(fundFamilyId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Creates a hypothetical waterfall via table data
 */
export const hypotheticalWaterfallTableCreate = (
    fundFamilyId: string,
    hypotheticalWaterfallAPITableCreateRequest: HypotheticalWaterfallAPITableCreateRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<HypotheticalWaterfallData>(
      {url: `/fund-family/${fundFamilyId}/financial-reporting/table-data`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: hypotheticalWaterfallAPITableCreateRequest
    },
      options);
    }
  


export const getHypotheticalWaterfallTableCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hypotheticalWaterfallTableCreate>>, TError,{fundFamilyId: string;data: HypotheticalWaterfallAPITableCreateRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof hypotheticalWaterfallTableCreate>>, TError,{fundFamilyId: string;data: HypotheticalWaterfallAPITableCreateRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hypotheticalWaterfallTableCreate>>, {fundFamilyId: string;data: HypotheticalWaterfallAPITableCreateRequest}> = (props) => {
          const {fundFamilyId,data} = props ?? {};

          return  hypotheticalWaterfallTableCreate(fundFamilyId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type HypotheticalWaterfallTableCreateMutationResult = NonNullable<Awaited<ReturnType<typeof hypotheticalWaterfallTableCreate>>>
    export type HypotheticalWaterfallTableCreateMutationBody = HypotheticalWaterfallAPITableCreateRequest
    export type HypotheticalWaterfallTableCreateMutationError = unknown

    export const useHypotheticalWaterfallTableCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hypotheticalWaterfallTableCreate>>, TError,{fundFamilyId: string;data: HypotheticalWaterfallAPITableCreateRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getHypotheticalWaterfallTableCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    